let initialized = false;

export function initializeClarity() {
  if (initialized) return;
  if (!import.meta.env.PROD) return;
  const id = import.meta.env.VITE_CLARITY_ID;
  if (!id) return;

  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', id);

  initialized = true;
}

export function stopClarity() {
  if (typeof window.clarity === 'function') {
    window.clarity('stop');
  }
}
